export class SearchOverlay {
  constructor (settings = {}) {
    this.options = $.extend({
      selectors: {
        searchTrigger: '.search-overlay-trigger',
        searchOverlay: '.search-overlay',
        searchInput: '.search-overlay .search-overlay__query',
        searchSubmit: '.search-overlay .search-overlay__submit'
      },
      classes: {
        searchOverlayOpen: 'search-overlay--open',
        bodyNoScroll: 'is--no-scroll'
      }
    },
    settings)
  }

  init () {
    this.addEvents()
  }

  addEvents () {
    const that = this
    const searchTrigger = $(that.options.selectors.searchTrigger)
    const searchOverlay = $(that.options.selectors.searchOverlay)

    searchTrigger
      .on({
        click: function (event) {
          event.preventDefault()

          that.openSearchOverlay()

          return false
        }
      })

    searchOverlay
      .on({
        click: function (event) {
          if ($(this).hasClass(that.options.classes.searchOverlayOpen)) {
            const target = $(event.target)

            if (!target.is(that.options.selectors.searchInput)) {
              if (!target.is(that.options.selectors.searchSubmit)) {
                that.closeSearchOverlay()
              }
            }
          }
        }
      })

    $(document)
      .on({
        keyup: function (event) {
          // Press "Escape"
          if (event.keyCode === 27) {
            that.closeSearchOverlay()
          }

          // Tab
          if (event.originalEvent.keyCode === 9) {
            const focusedElement = $(this).find(':focus')

            const searchOverlay = $(that.options.selectors.searchOverlay)

            if (focusedElement.closest(that.options.selectors.searchOverlay).length === 0) {
              if (searchOverlay.hasClass(that.options.classes.searchOverlayOpen)) {
                that.closeSearchOverlay()
              }
            } else {
              if (!searchOverlay.hasClass(that.options.classes.searchOverlayOpen)) {
                that.openSearchOverlay()
              }
            }
          }
        }
      })
  }

  openSearchOverlay () {
    const that = this
    const searchInput = $(that.options.selectors.searchInput)
    const searchOverlay = $(that.options.selectors.searchOverlay)

    searchOverlay
      .addClass(that.options.classes.searchOverlayOpen)

    $('body')
      .addClass(that.options.classes.bodyNoScroll)

    if (!($('html').is('.xs, .sm'))) {
      searchInput
        .focus()
    }
  }

  closeSearchOverlay () {
    const that = this

    $(that.options.selectors.searchOverlay)
      .removeClass(that.options.classes.searchOverlayOpen)

    $('body')
      .removeClass(that.options.classes.bodyNoScroll)
  }
}

export default SearchOverlay
